import {
  Question,
  EndJourneyResponse,
  RespondentInfo,
} from '../../../types/end-journey'
import { rawApi } from '../../../app/api'

export interface AssessmentData {
  intro: any
  questions: Question[]
  outro: any
  user: {
    email: string
    peers: RespondentInfo[]
    reportees: RespondentInfo[]
    managers: RespondentInfo[]
    timezone: string
    company?: string
  }
}

export interface ApiResponse {
  sessionId: string
  answers: Array<{
    answers: Array<{
      _id: string
      value: string
      label: string
    }>
    question: string
    otherAnswer?: string
    leadershipValue?: string
  }>
  currentQuestion?: string
}

export const endJourneyApi = {
  // Fetch assessment data (questions and intro)
  async getAssessmentData(userId: string) {
    return rawApi
      .url(`/v2/user/end-journey/${userId}`)
      .get()
      .json<AssessmentData>()
  },

  // Submit a single response
  async submitResponse(userId: string, response: EndJourneyResponse) {
    await rawApi
      .url(`/v2/user/end-journey/${userId}/responses`)
      .post(response)
      .json()
  },

  // Get existing responses for resuming
  async getResponses(userId: string) {
    return rawApi
      .url(`/v2/user/end-journey/${userId}/responses`)
      .get()
      .json<ApiResponse>()
  },
}
